import React, { useEffect, useState } from "react";
import salesDood2 from "../utils/salesDood2.png";
import {
  AiOutlineSetting,
  AiOutlineSearch,
  AiOutlineMail,
  AiOutlineBell,
  AiOutlineUser,
  AiOutlineClose,
} from "react-icons/ai"; // AiOutline icons

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";
import "../css/Header.css"

const Header = () => {

  const [accessGroup, setAccessGroup] = useState("")
  const [hideRightSideBar, sethideRightSideBar] = useState(true)
  const navigate = useNavigate();
  const [searchItem, setSearchItem] = useState("");
  const [team, setTeam] = useState("");
  const [dept, setDept] = useState("");

  const handleSearchChange = (e) => {
    setSearchItem(e.target.value);
  };

  const clearSearchItem = () => {
    setSearchItem("");
  };

  const handleChange = (e) => {
    console.log("team is selected:1", e.target.value);
    setTeam(e.target.value);
  };

  const handleDeptChange = (e) => {
    const userSelectedDepartment = e.target.value;
    console.log("department is selected:", userSelectedDepartment);
    setDept(userSelectedDepartment);
    localStorage.setItem("currentSelectedDepartment", userSelectedDepartment);
    window.location.reload();
  };

  const handleClick = () => {
    
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));

    const userAccessGroup = currentUserObject[0].accessgrp;

      if(userAccessGroup?.trim().toUpperCase() === "CADMIN"){
        navigate("/home");
      }else{
        navigate("/leads");
      }
    
    
  };

  const [userDepartmentList, setUserDepartment] = useState(null);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    console.log("userDepartmentList in Header", userDepartmentList);
  }, [userDepartmentList]);

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const currentUserName = localStorage.getItem("currentUserName");
    const currentDepartment = localStorage.getItem("currentSelectedDepartment");
    console.log("currentUser in Header", currentUser);

    const userAccessGroup = currentUser[0].accessgrp;

    if (currentUser) {
      setUserDepartment(currentUser); // Set the department number
      setUserName(currentUserName); // Set the department number
      setDept(currentDepartment);
      setAccessGroup(userAccessGroup)
    } else {
      console.log("No currentUser found in localStorage");
      setUserDepartment(null); // Optionally handle the case when there is no user
    }
  }, []);

  const toggleHideRightSideBar = () => {
    sethideRightSideBar(prev => !prev)
  }

  return (
    // <header className="bg-gradient-to-r from-blue-200 to-blue-500 text-black p-4 flex items-center justify-between fixed w-full top-0 left-0 z-20 text-black">
    // <header style={{ backgroundColor: '#F4F1EA' }} className="text-black p-4 flex items-center justify-between fixed w-full top-0 left-0 z-20 text-black">
    <header
      style={{ backgroundColor: "#f8f8f8" }}
      className="text-black p-1 flex items-center justify-between fixed w-full top-0 left-0 z-20 text-black"
    >
      {/* Menu Button (Sidebar Toggle) */}
      <div className="flex gap-6 justify-between items-center header-logo-togglebutton-container">


        {/* Logo */}
        <div className="flex gap-2">
          <img
            onClick={handleClick}
            src={salesDood2}
            alt="Salesdood"
            className="rounded  w-auto h-14 text-xl text-black font-semibold cursor-pointer "
          />
        </div>

        <button onClick={() => toggleHideRightSideBar()} className="header-sidebar-iconset-open">&#60;</button>
      </div>

      <div className={ hideRightSideBar ? "header-right-part flex justify-center items-center gap-2 header-hide-right-part" : "header-right-part flex justify-center items-center gap-2"}>
        {/* Search Bar */}
        <div className="relative ">
          <input
            type="text"
            value={searchItem}
            onChange={handleSearchChange}
            placeholder="Search Anything …"
            className="w-full py-2 pl-10 pr-4 rounded-lg bg-white text-black placeholder-gray-400 border border-none shadow-sm"
          />
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            <AiOutlineSearch className="text-gray-500" />
          </div>
          {/* Clear "X" Icon */}
          {searchItem && (
            <div
              className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={clearSearchItem} // Clear the search term when clicked
            >
              <AiOutlineClose className="text-gray-500" />
            </div>
          )}
        </div>

        {/* Team Select */}
        <div>
          <FormControl
            sx={{
              m: 1,
              minWidth: 110,
              "& .MuiInputBase-root": {
                fontSize: "14px",
              },
            }}
            // sx={{
            //   m: 1,
            //   minWidth: 110, // Adjust width if needed
            //   "& .MuiInputBase-root": {
            //     fontSize: "12px", // Smaller font size
            //     // padding: "2px 4px", // Reduce padding
            //     height: "30px", // Reduce height
            //   },
            //   "& .MuiInputLabel-root": {
            //     fontSize: "12px", // Smaller label font size
            //   },
            // }}
            size="small"
          >
            <InputLabel
              id="demo-select-small-label"
              sx={{
                fontFamily: "'Figtree', sans-serif", // Custom font for label
                fontSize: "14px", // Optional: Adjust font size
              }}
            >
              Team
            </InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={team}
              label="Team"
              onChange={handleChange}
              MenuProps={{
                PaperProps: {
                  sx: {
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", // Reduced shadow
                  },
                },
              }}
            >
              {/* borderRadius: "8px", 
                    fontFamily: "'Figtree', sans-serif", */}

              <MenuItem value="">
                <em className="text-gray-300">Select Team</em>
                {/* Select */}
              </MenuItem>
              <MenuItem value="general">General</MenuItem>
              <MenuItem value="teamA">Team A</MenuItem>
              <MenuItem value="teamB">Team B</MenuItem>
              <MenuItem value="teamC">Team C</MenuItem>
              <MenuItem value="teamD">Team D</MenuItem>
            </Select>
          </FormControl>
        </div>

        {/* Department Select */}
        <div>
          <FormControl
            sx={{
              m: 1,
              minWidth: 110,
              "& .MuiInputBase-root": {
                fontSize: "14px",
              },
            }}
            size="small"
          >
            <InputLabel
              id="demo-select-small-label"
              sx={{
                fontFamily: "'Figtree', sans-serif", // Custom font for label
                fontSize: "14px", // Optional: Adjust font size
              }}
            >
              Department
            </InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={dept}
              label="Department"
              onChange={handleDeptChange}
              MenuProps={{
                PaperProps: {
                  sx: {
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", // Reduced shadow
                  },
                },
              }}
            >
              {/* borderRadius: "8px", 
                    fontFamily: "'Figtree', sans-serif", */}

              <MenuItem value="">
                <em className="text-gray-300">Select Department</em>
                {/* Select */}
              </MenuItem>
              {userDepartmentList?.map((itemDept) => {
                return (
                  <MenuItem value={itemDept.DEPTNO?.trim()}>
                    {itemDept.DEPTNO?.trim()}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>

        {/* Notification and Profile Icons */}
        <div className="header-sidebar-iconset flex items-center justify-center gap-6 space-x-4 bg-none px-4 py-2 rounded-md">

          <button className="text-black  relative">
            <AiOutlineMail className="text-xl" />
            <span className="absolute bottom-1.5 left-2 bg-green-700 text-white text-xs  rounded-full w-4 h-4 m-1 flex items-center justify-center">
              4
            </span>
          </button>
          <button className="text-black relative">
            <AiOutlineBell className="text-xl" />
            <span className="absolute bottom-1.5 left-1.5 bg-green-700 text-white text-xs  rounded-full w-4 h-4 m-1 flex items-center justify-center">
              7
            </span>
          </button>
          <button className="text-black">
            <AiOutlineUser className="text-xl" />
          </button>
          <button className="text-black">
            <AiOutlineSetting className="text-xl" />
          </button>
          <div className="flex flex-col justify-center items-center gap-2">
            <img
              src="https://static.vecteezy.com/system/resources/previews/024/766/958/non_2x/default-male-avatar-profile-icon-social-media-user-free-vector.jpg"
              alt="User Avatar"
              className="w-10 h-10 rounded-full object-cover"
            />
            <p>{userName}</p>
            <p style={{fontSize:"12px", fontWeight:"bold"}}>{accessGroup}</p>
          </div>
        </div>

        <button onClick={() => toggleHideRightSideBar()} className="header-sidebar-iconset-close" >&#62;</button>
      </div>

    </header>
  );
};

export default Header;
